export const RAW_TEXT_BLOCK = 'Text';
export const RESERVED_BLOCK_NAMES = [RAW_TEXT_BLOCK];
//# sourceMappingURL=constants.js.map